import { render, staticRenderFns } from "./Signatures.vue?vue&type=template&id=f12c5878"
import script from "./Signatures.vue?vue&type=script&lang=js"
export * from "./Signatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports